import React from "react";
import AllToolTip from "../Tooltip/AllToolTips";

const CardHeader = ({ name,tooltipText }) => {
  return (
    <div className="card-header bg-gray-700 min-h-auto py-5 justify-content-start">
      <h5 className="card-label font-weight-bold text-white m-0">{name}</h5>

      {tooltipText && 
      <AllToolTip text={tooltipText} />
      }
    </div>
  );
};

export default CardHeader;
